import React from 'react';

interface ICalendarIcon {
  disabled?: boolean;
}
const CalendarIcon: React.FC<ICalendarIcon> = props => {
  const { disabled } = props;
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z"
        stroke={disabled ? '#A1AFC5' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 1.33325V3.99992"
        stroke={disabled ? '#A1AFC5' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 1.33325V3.99992"
        stroke={disabled ? '#A1AFC5' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66675H14"
        stroke={disabled ? '#A1AFC5' : 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
